<div class="mt-3">
  <label for="installationAbilitySelector" class="form-label">View by Installation Ability</label>

  <ng-select
    [items]="abilities"
    [multiple]="true"
    placeholder="Select or start typing..."
    [formControl]="formControl"
    [closeOnSelect]="false"
    [clearSearchOnAdd]="true"
    data-testid="installation-ability-selector"
  >
    <ng-template ng-option-tmp let-item="item">
      <input
        type="checkbox"
        [checked]="formControl.value.includes(item)"
      />
      {{ item }}
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      @for (item of items; track item) {
        <div class="ng-value">
          <span class="ng-value-label">{{ item }}</span>
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        </div>
      }
    </ng-template>
  </ng-select>
</div>
